import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import List, { ListSubheader } from "material-ui/List";
import Drawer from "material-ui/Drawer";
import Divider from "material-ui/Divider";
import Button from "material-ui/Button";

import BusinessCenterIcon from "material-ui-icons/BusinessCenter";
import InsertChartIcon from "material-ui-icons/InsertChart";
import AssignmentIcon from "material-ui-icons/Assignment";
import ExitToAppIcon from "material-ui-icons/ExitToApp";
import DrawerMenuItem from "./DrawerMenuItem";
import DrawerHeaderContainer from "./DrawerHeaderContainer";

const styles = theme => ({
  list: {
    width: 250,
    flex: "initial"
  }
});

const AppDrawer = props => {
  const {
    docked,
    open,
    onCloseDrawer,
    classes,
    externalLinks,
    conductorAccountUrl,
    forgetToken,
    mode
  } = props;

  const renderExternalLinks = () => {
    return (
      externalLinks &&
      externalLinks.map((link, i) => {
        if (!link) {
          return <Divider key={i} />;
        }

        return (
          <DrawerMenuItem
            key={i}
            {...link}
            onCloseDrawer={onCloseDrawer}
            icon={<ExitToAppIcon />}
          />
        );
      })
    );
  };

  const renderDevButtons = () => {
    if (mode === "PROD") {
      return null;
    }

    return (
      <List
        className={classes.list}
        disablePadding
        subheader={<ListSubheader>Dev mode actions</ListSubheader>}
      >
        <Button color="primary" onClick={forgetToken}>
          Forget Token
        </Button>
      </List>
    );
  };

  return (
    <Drawer
      className={classes.drawer}
      open={open}
      type={docked ? "persistent" : "temporary"}
      onClick={onCloseDrawer}
    >
      <div>
        <List className={classes.list} disablePadding>
          <DrawerHeaderContainer />

          <DrawerMenuItem
            url="/overview"
            label="Overview"
            onCloseDrawer={onCloseDrawer}
            icon={<InsertChartIcon />}
          />
          <DrawerMenuItem
            url="/accounts"
            label="Accounts"
            onCloseDrawer={onCloseDrawer}
            icon={<BusinessCenterIcon />}
          />
          <DrawerMenuItem
            url={conductorAccountUrl}
            label="Conductor account"
            onCloseDrawer={onCloseDrawer}
            icon={<AssignmentIcon />}
          />

          <Divider />

          {renderExternalLinks()}
        </List>
        <Divider />
        {renderDevButtons()}
      </div>
    </Drawer>
  );
};

AppDrawer.propTypes = {
  mode: PropTypes.string,
  docked: PropTypes.bool.isRequired,
  open: PropTypes.bool,
  externalLinks: PropTypes.array,
  conductorAccountUrl: PropTypes.string.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
  forgetToken: PropTypes.func.isRequired
};

export { AppDrawer };

export default withStyles(styles, { name: "AppDrawer" })(AppDrawer);



// WEBPACK FOOTER //
// ./src/AppDrawer.js